export default __webpack_public_path__ + "static/incident-management-ccf62c7bc739017b387977dc6cf60039.svg";